export const brand = {
  primary: "#2A8DFF",
  text: "#0F172A",
  muted: "#64748B",
  mist: "#F1F5F9",
  dark: "#0A0F1E",
  success: "#22C55E",
  white: "#FFFFFF",
};